export const heroSection = {
  heading: {
    content: `
#      The Health & Wellness Blogs
      
      `,
    styles: {},
  },
  description: {
    content:
      'Explore our health and wellness blogs for trusted health information, expert insights, and practical tips on medical conditions, prevention, and healthy living to help you make informed decisions about your wellbeing.',
    styles: {},
  },
} as const;

export const blogsSearch = {
  inputPlaceholder: 'Search by Name, Speciality or Condition.... ',
  dropdownLabel: 'All Categories',
  searchButtonLabel: 'Search',
  dropdownOptions: [
    'All Categories',
    'Sexual Health',
    'Gastroenterology',
    'Trauma & Orthopaedic',
    'Urology & Andrology',
    'Aesthetic',
  ],
} as const;
